import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col md:flex-row justify-between gap-8 md:gap-6">
          <div className="max-w-sm">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-500 text-background-50 font-heading font-bold text-sm">
                张
              </span>
              <span className="font-heading text-lg font-bold">张柏芝资讯站</span>
            </div>
            <p className="text-sm text-primary-200 leading-relaxed">
              专注于张柏芝最新影视作品、个人资料与新闻动态的明星资讯门户，内容仅供粉丝与娱乐资讯读者参考阅读。
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 flex-1">
            <div>
              <h4 className="font-heading text-sm font-semibold mb-3 text-background-50">
                <Link to="/news" className="cursor-pointer hover:text-accent-400">内容导航</Link>
              </h4>
              <ul className="space-y-2 text-sm text-primary-200">
                <li><Link to="/news" className="cursor-pointer hover:text-accent-400">新闻资讯</Link></li>
                <li><Link to="/works" className="cursor-pointer hover:text-accent-400">影视作品</Link></li>
                <li><Link to="/specials" className="cursor-pointer hover:text-accent-400">专题合集</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-heading text-sm font-semibold mb-3 text-background-50">
                <Link to="/profile" className="cursor-pointer hover:text-accent-400">关于张柏芝</Link>
              </h4>
              <ul className="space-y-2 text-sm text-primary-200">
                <li><Link to="/profile" className="cursor-pointer hover:text-accent-400">个人资料</Link></li>
                <li><Link to="/search" className="cursor-pointer hover:text-accent-400">搜索中心</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-heading text-sm font-semibold mb-3 text-background-50">
                <Link to="/about" className="cursor-pointer hover:text-accent-400">站点信息</Link>
              </h4>
              <ul className="space-y-2 text-sm text-primary-200">
                <li><Link to="/about" className="cursor-pointer hover:text-accent-400">关于站点</Link></li>
                <li><Link to="/about" className="cursor-pointer hover:text-accent-400">联系我们</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-700 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-300">
          <p>© 2026 张柏芝资讯站. 本站内容均为虚拟演示，非官方真实信息。</p>
          <p>Fan-made Portal · Demo Content Only</p>
        </div>
      </div>
    </footer>
  );
}